<div class="createReason">
<div class="crt">Create Reason</div>
<div class="close" (click)="closeDialog()"><mat-icon style="cursor: pointer;">close</mat-icon></div>
<form [formGroup]="creatCustomer" >
<div class="feild">
    <div class="dropDown">
        <label class="label">Reason For:</label>
        <select class="Dropdown" (change)="ChangeList($event)" class="form-control" formControlName="reasonfor">
             <option style="display: none;" value="" disabled selected>Select your option</option>
            <option value="Consumer">Customer</option>
            <option value="Driver">Driver</option>
        </select>
        <div *ngIf=" 
      Submitted  && f['reasonfor'].invalid
       " class="danger">
           <div class="error" style="color: red" *ngIf="f['reasonfor'].errors && f['reasonfor'].errors['required']">
             *Mandatory Field
           </div>
         </div>
    </div>
    <div class="dropDown">
        <label class="label">Reason:</label>
        <textarea #yourInput placeholder="reason" class="amount"  formControlName="reason"
            (keyup)="sendit(yourInput.value)" rows="4" cols="50"></textarea>
            <div *ngIf=" 
            Submitted  && f['reason'].invalid
             " class="danger">
                 <div class="error" style="color: red" *ngIf="f['reason'].errors && f['reason'].errors['required']">
                   *Mandatory Field
                 </div>
               </div>
    </div>
<!-- <div class="button"><button class="butt" (click)="createreason(creatCustomer.valid)">Submit</button></div> -->
<div class="submit">
  <!-- <button class="Cbutton" (click)="reset()">Cancel</button> -->
  <button type="button"  (click)="createreason(creatCustomer.valid)" class="btn__primary">Submit</button>
</div>
</div>
</form>
</div>
